import type { CallRecord } from '@/store/features/telephony.feature';

const ENDED_LABEL: Record<string, string> = {
  completed: 'Answered',
  busy: 'Busy',
  no_answer: 'No answer',
  failed: "Didn't connect",
  canceled: 'Canceled',
  expired: "Didn't connect",
  blocked: 'Not placed',
};

/** A call length as m:ss. */
export function clock(seconds: number): string {
  const s = Math.max(0, Math.floor(seconds));
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;
}

/** What a connected minute costs, for the bar: "1 credit/min", "32 credits/min". */
export function rateLabel(credits: number): string {
  return `${credits} ${credits === 1 ? 'credit' : 'credits'}/min`;
}

/** How a call ended, for the bar and the unsaved reminder. */
export function endedSummary(record: CallRecord | undefined): string {
  if (!record) return 'Call ended';
  if (record.direction === 'voicemail')
    return record.durationSeconds
      ? `Voicemail · ${clock(record.durationSeconds)}`
      : 'Voicemail';
  const label = ENDED_LABEL[record.status] ?? 'Call ended';
  return record.status === 'completed' && record.durationSeconds
    ? `${label} · ${clock(record.durationSeconds)}`
    : label;
}

/** A phone keypad's keys, in its order. */
export const KEYS = [
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '*',
  '0',
  '#',
];
